import { Component, EventEmitter, Output } from '@angular/core';
import { Layer } from '../../../../../../../shared/models/layer';
import { faSliders } from '@fortawesome/free-solid-svg-icons';
import { LayerService } from '../../../../../../../shared/services/layer.service';

@Component({
  selector: 'app-layers',
  templateUrl: './layers.component.html',
  styleUrl: './layers.component.scss'
})
export class LayersComponent {
  @Output() legendConsultClicked = new EventEmitter<void>();
  
  layer: Layer;
  faLayer = faSliders;

  constructor(private layerService: LayerService) {
    this.layer = this.layerService.getLayerState();
  }

  onLayerChange(): void {
    this.layerService.updateLayerState(this.layer);
  }

  onLegendConsultClick(): void {
    this.legendConsultClicked.emit(); 
  }
  
}
